import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TableError } from '../../types/common';
import {
  FeeService,
  Wealthlane_AwardService_Dtos_Fee_UpdateSecFeeDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePutSecFee = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void,
  onError: (message: string, errors: TableError[]) => void,
  setEditLoading?: (loading: boolean) => void
): UseMutationResult<
  Array<Wealthlane_AwardService_Dtos_Fee_UpdateSecFeeDto>,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      setEditLoading && setEditLoading(true);

      return await handleRequest(FeeService.putApiAwardApiAppFeeSecFee(payload));
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null && response?.isSuccess) {
          await queryClient.invalidateQueries('getSecFeeList');
          setEditLoading && setEditLoading(false);
          onClose && onClose();
          toast.success(<ToastComponent label='Success' message={`SEC Fee Edited.`} />);
        } else {
          throw {
            message: response?.message,
            errors: response?.errors,
            error: new Error(),
          };
        }
        onClose && onClose();
        setEditLoading && setEditLoading(false);
      },
      onError: (err: any) => {
        console.log('error', err);
        setEditLoading && setEditLoading(false);
        onError && onError(err?.message, err?.errors);
        onClose && onClose();
      },
    }
  );
};

export default usePutSecFee;
